module.exports = __webpack_public_path__ + "assets/690f58212a6c8a5332dbcfc04f89d9cb.png";